import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Paper, Tab, Tabs } from '@mui/material';
import Layers from '../../components/maps/Layers';
import { LayerType } from '../../models/types/layerType';
import { authService } from '../../services/auth.service';

const PageLayers: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    setIsAdmin(authService.isAdmin());
  }, []);

  const onTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  }

  return (
    <>
      <header className="app-header">
        <h1>Kaartlagen</h1>
        <p className="header-sub-title">
          Hier vindt u een overzicht van alle kaartlagen die beschikbaar zijn voor gebruikers van infraplannen.nl.<br/>
        </p>
      </header>

      <div className="content text-left">
        <Tabs
          value={tabValue}
          onChange={onTabChange}
          aria-label="icon position tabs example"
        >
          {isAdmin && <Tab iconPosition="start" label="Openbare kaartlagen" />}
          <Tab label="Organisatie kaartlagen" />
        </Tabs>
        {isAdmin && tabValue === 0 && (
          <Paper sx={{ width: '100%' }}>
            <div className="header">
              <h4>Overzicht van alle openbare kaartlagen</h4>
              <p>
                Stel hier in welke kaartlagen je wilt delen met alle organisaties van infraplannen.nl.
              </p>

              <Layers type={LayerType.PUBLIC} key="public" />
            </div>
          </Paper>
        )}

        {(isAdmin ? tabValue === 1 : tabValue === 0) && (
          <Paper sx={{ width: '100%' }}>
            <div className="header">
              <h4>Overzicht van alle organisatie kaartlagen</h4>
              <p>
                Stel hier in met welke organisaties je de kaartlagen wilt delen.
              </p>

              <Layers type={LayerType.ASSET} key="asset" />
            </div>
          </Paper>
        )}

      </div>
      
      <Outlet /> 
    </>
  );
};

export default PageLayers;